import React, { createContext, useContext, useState } from "react";

// Criação do contexto
const OrcamentoContext = createContext();

// Provedor do contexto
export const OrcamentoProvider = ({ children }) => {
  const [kitOrcamento, setKitOrcamento] = useState(null);
  const [userData, setUserData] = useState({})
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (formData) => {
    setLoading(true);
    setUserData(formData)
    try {
      const response = await fetch("https://renovera.com.br/api/solplace/comparador-kit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          params: {
            admin_id: 11,
            client_email: formData.client_email,
            client_telefone: formData.client_telefone,
            client_name: formData.client_name,
            estrutura_fixacao: formData.estrutura_fixacao,
            marca_inversor: formData.marca_inversor,
            marca_modulo: formData.marca_modulo,
            potencia_pico: formData.potencia_pico,
            rede_ca: formData.rede_ca,
            state_id: formData.state_id,
            string_box: formData.string_box,
            tensao_rede_ca: formData.tensao_rede_ca,
            zip: formData.zip,
          }
        }),
      });

      if (response.ok) {
        const data = await response.json();
        setKitOrcamento(data);
      } else {
        console.error("Erro na requisição:", response.statusText);
        setKitOrcamento(null);
      }
    } catch (error) {
      console.error("Erro:", error);
      setKitOrcamento(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <OrcamentoContext.Provider value={{ kitOrcamento, handleSubmit, userData, loading }}>
      {children}
    </OrcamentoContext.Provider>
  );
};

// Hook para usar o contexto
export const useOrcamentoContext = () => {
  return useContext(OrcamentoContext);
};
